/**
 * View component for /content-modules/:contentModuleId
 *
 * Displays a single contentModule from the 'byId' map in the contentModule reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, history, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import third-party libraries
import _ from 'lodash';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { DateTime } from 'luxon';

// import utilities
import filterUtils from '../../../global/utils/filterUtils';
import progressUtils from '../../../global/utils/progressUtils';
import videoUtils from "../../../global/utils/videoUtils.js";

// import actions
import * as moduleCertificateActions from '../../moduleCertificate/moduleCertificateActions';
import * as resourceLinkActions from '../../resourceLink/resourceLinkActions';
import * as contentModuleActions from '../contentModuleActions';
import * as userNodeActions from '../../userNode/userNodeActions';
import * as userModuleActions from '../../userModule/userModuleActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import ContentModuleLayout from '../components/ContentModuleLayout.js.jsx';

class ContentModuleNodeRedirect extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { loggedInUser, dispatch, match } = this.props;
    // tm - node view

    dispatch(contentModuleActions.fetchSingleBySlug(match.params.contentModuleSlug)).then(cmAction => {



      // fetch user's previous UserNodes for this module
      dispatch(moduleCertificateActions.fetchListIfNeeded('_user', loggedInUser._id, '_contentModule', cmAction.item._id, 'status', 'completed'));

      dispatch(userModuleActions.fetchSingleUserModuleByModule(cmAction.item._id)).then(umAction => {
        if(!umAction.success || !umAction.item._id) {
          alert("AN ERROR OCCURRED 0x678772. PLEASE TRY LOGGING OUT AND BACK IN.")
        } else {
          // console.log("DEBUG SINGLE USER MODULE", umAction)
          // redirect user to athens for this usermodule

          // /content-modules/{moduleId}/user-module/{umId}/nodes/{nodeId}

          window.location = `${simUrl}/content-modules/${cmAction.item._id}/user-module/${umAction.item._id}/nodes/${match.params.nodeId ? match.params.nodeId : umAction.item._lastNode}`
        }
      })
    });
  }

  render() {
    const {
      loggedInUser
      , location
      , match
      , contentModuleStore
      , userModuleStore
    } = this.props;

    const isAdmin = loggedInUser ? loggedInUser.admin : null;
    /**
     * use the selected.getItem() utility to pull the actual contentModule object from the map
     */
    const selectedContentModule = contentModuleStore.selected.getItem();
    const selectedUserModuleId = userModuleStore.selected.id;
    
    return (
      <ContentModuleLayout>
        <div className="flex">
          <Helmet
            title={"...loading | Pro-ficiency"}
          />
          <section className="section top-spacer-only">
            <div className="yt-container">
            </div>
          </section>
        </div>
      </ContentModuleLayout>
    )
  }
}


ContentModuleNodeRedirect.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    loggedInUser: store.user.loggedIn.user
    , contentModuleStore: store.contentModule
    , userModuleStore: store.userModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(ContentModuleNodeRedirect)
);



// WEBPACK FOOTER //
// modules/contentModule/views/ContentModuleNodeRedirect.js.jsx